module.exports = __webpack_public_path__ + "img/63.12489e42.jpg";